import Vue from "vue";
import Router from "vue-router";
import homePage from "@/components/homePage";
import index from "@/components/index";

import journalismNotice from "@/components/journalismNotice";

import affirm from "@/components/affirm/affirm";
//开始认定首页
import beginHomePage from "@/components/affirm/beginHomePage";
//认定说明
import affirmExplain from "@/components/affirm/affirmExplain";
//个人信息
import personalInformation from "@/components/affirm/personalInformation";
//开始认定
import beginAffirm from "@/components/affirm/beginAffirm";
//资料上传
import affirmUploadData from "@/components/affirm/affirmUploadData";
//取消认定
import affirmcancel from "@/components/affirm/affirmcancel";
//认定缴费
import affirmPayTheFees from "@/components/affirm/affirmPayTheFees";
//培训缴费
import trainPayTheFees from "@/components/affirm/trainPayTheFees";
//认定记录
import affirmrecord from "@/components/affirm/affirmrecord";
//认定记录
import affirmChangePassword from "@/components/affirm/affirmChangePassword";
//消息通知
import affirmMessageNotification from "@/components/affirm/affirmMessageNotification";
//消息通知
import affirmProfessionalStandard from "@/components/affirm/affirmProfessionalStandard";
//认定支付
import affirmPay from "@/components/affirm/affirmPay";
//登录
import login from "@/components/login";
import personRegister from "@/components/personRegister";
import unitRegister from "@/components/unitRegister";
import examHomePage from "@/components/exam/examHomePage";
import examPrepositionPage from "@/components/exam/examPrepositionPage";
import exam from "@/components/exam/exam";
import exerciseHomePage from "@/components/exercise/exerciseHomePage";
import exercisePreposition from "@/components/exercise/exercisePreposition";
import exercisePrepositionExpert from "@/components/exercise/exercisePrepositionExpert";
import mockTest from "@/components/exercise/mockTest";
import exerciseSequence from "@/components/exercise/exerciseSequence";
import train from "@/components/train/train";
import trainHomePage from "@/components/train/homePage";
import learningConsultation from "@/components/train/learningConsultation";
import courseCenter from "@/components/train/courseCenter"; //课程中心
import coursePay from "@/components/train/coursePay"; //课程缴费
import trainingPlan from "@/components/train/trainingPlan";
import liveClassroom from "@/components/train/liveClassroom";
import live from "@/components/train/live";
import personalCenter from "@/components/train/personalCenter/personalCenter";
import mySelfBuyCourse from "@/components/train/personalCenter/mySelfBuyCourse";
import trainingProgram from "@/components/train/personalCenter/trainingProgram";
import myAccount from "@/components/train/personalCenter/myAccount";
import accountSet from "@/components/train/personalCenter/accountSet";
import courseDetail from "@/components/train/courseDetail";
import video from "@/components/train/video";
import chapterTest from "@/components/train/chapterTest";
import trainPlanPersonal from "@/components/train/personalCenter/trainPlanPersonal";
import trainPlanCourse from "@/components/train/personalCenter/trainPlanCourse";
import resetThePassword from "@/components/train/personalCenter/resetThePassword";
import journalismNoticeDetail from "@/components/journalismNoticeDetail";
import HeddleChangeArea from "@/components/HeddleChangeArea";
import HeddleChangeAreaHomePage from "@/components/HeddleChangeAreaHomePage";
import courseBuyDetail from "@/components/train/courseBuyDetail";
import scoreInquire from "@/components/inquire/scoreInquire";
import certificateInquire from "@/components/inquire/certificateInquire";
import bigHomePage from "@/components/bigHomePage";
import exLogin from "@/components/exLogin";
import retrievePassword from "@/components/retrievePassword";

//招生信息
import enrollmentGuide from "@/components/enrollmentGuide";

//互联网+
import internetplusIndex from "@/components/internetplus/index";
import internetplusHomePage from "@/components/internetplus/homePage";

import journalismNoticenet from "@/components/internetplus/journalismNotice";
import journalismNoticeDetailnet from "@/components/internetplus/journalismNoticeDetail";
//登录
import loginnet from "@/components/internetplus/login";
//注册
import personRegisternet from "@/components/internetplus/personRegister";

//考试登录页
import examLogin from "@/components/examLogin";

//关于我们
import aboutUs from "@/components/aboutUs";

Vue.use(Router);
//解决重复点击报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  routes: [
    //系统首页
    {
      path: "/",
      component: index,
      redirect: "/homePage",
      children: [
        //首页
        {
          path: "/homePage",
          component: homePage
        },
        //首页导航跳转
        {
          path: "/journalismNotice/:navId",
          component: journalismNotice
        },
        {
          path: "/enrollmentGuide",
          component: enrollmentGuide
        },

        //详情
        {
          path: "/journalismNoticeDetail/:id/:navName",
          component: journalismNoticeDetail
        },
        //认定相关
        {
          path: "/affirm/:workTypeLevelState/:state",
          redirect: "/beginHomePage/:workTypeLevelState/:state",
          component: affirm,
          //认定页面 中再加层级包含 就在其中加 children
          children: [
            //认定说明
            {
              path: "/affirmExplain",
              component: affirmExplain
            },
            //开始认定首页
            {
              path: "/beginHomePage/:workTypeLevelState/:state",
              component: beginHomePage
            },
            // 个人信息
            {
              path: "/personalInformation/:workTypeLevelState/:state",
              component: personalInformation
            },
            //开始认定
            {
              path: "/beginAffirm/:workTypeLevelState/:state",
              component: beginAffirm
            },
            //认定资料上传
            {
              path: "/affirmUploadData/:workTypeLevelState/:state",
              component: affirmUploadData
            },
            //取消申报
            {
              path: "/affirmcancel/:workTypeLevelState/:state",
              component: affirmcancel
            },
            //认定缴费
            {
              path: "/affirmPayTheFees/:workTypeLevelState/:state",
              component: affirmPayTheFees
            },
            //培训缴费
            {
              path: "/trainPayTheFees/:workTypeLevelState/:state",
              component: trainPayTheFees
            },
            //我的认定
            {
              path: "/affirmrecord/:workTypeLevelState/:state",
              component: affirmrecord
            },
            //修改密码
            {
              path: "/affirmChangePassword",
              component: affirmChangePassword
            },
            //消息通知
            {
              path: "/affirmMessageNotification",
              component: affirmMessageNotification
            },
            //职业标准
            {
              path: "/affirmProfessionalStandard/:workTypeLevelState",
              component: affirmProfessionalStandard
            }
          ]
        },
        //登录跳转
        {
          name: "login",
          path: "/login",
          component: login
        },
        //个人注册
        {
          name: "personRegister",
          path: "/personRegister",
          component: personRegister
        },
        //成绩查询
        {
          path: "/scoreInquire",
          component: scoreInquire
        },
        //成绩查询
        {
          path: "/certificateInquire",
          component: certificateInquire
        },
        //关于我们
        {
          path: "/aboutUs",
          component: aboutUs
        }
      ]
    },
    //考试登录页
    {
      name: "examLogin",
      path: "/examLogin",
      component: examLogin
    },
    //互联网+
    {
      path: "/net",
      component: internetplusIndex,
      redirect: "/netHomePage",
      children: [
        //首页
        {
          path: "/netHomePage",
          component: internetplusHomePage
        },
        //首页导航跳转
        {
          path: "/journalismNoticenet/:navId",
          component: journalismNoticenet
        },
        //详情
        {
          path: "/journalismNoticeDetailnet/:id/:navName",
          component: journalismNoticeDetailnet
        },
        //首页导航跳转
        {
          path: "/loginnet",
          component: loginnet
        },
        //详情
        {
          path: "/personRegisternet",
          component: personRegisternet
        }
      ]
    },
    {
      name: "bigHomePage",
      path: "/bigHomePage",
      component: bigHomePage
    },
    {
      name: "exLogin",
      path: "/exLogin",
      component: exLogin
    },
    //单位注册
    {
      name: "unitRegister",
      path: "/unitRegister",
      component: unitRegister
    },
    {
      name: "affirmPay",
      path: "/affirmPay/:orderId/:state",
      component: affirmPay
    },
    {
      name: "examHomePage",
      path: "/examHomePage",
      component: examHomePage
    },
    {
      name: "examPrepositionPage",
      path: "/examPrepositionPage",
      component: examPrepositionPage
    },
    {
      name: "exam",
      path: "/exam",
      component: exam
    },
    {
      name: "exerciseHomePage",
      path: "/exerciseHomePage",
      component: exerciseHomePage
    },
    {
      name: "exercisePreposition",
      path: "/exercisePreposition/:testType",
      component: exercisePreposition
    },
    {
      name: "exercisePrepositionExpert",
      path: "/exercisePrepositionExpert/:testType",
      component: exercisePrepositionExpert
    },
    {
      name: "mockTest",
      path: "/mockTest/:courseId/:testQueNum/:queType",
      component: mockTest
    },
    {
      name: "mockTestTestId",
      path: "/mockTest/:testId",
      component: mockTest
    },
    {
      name: "exerciseSequence",
      path: "/exerciseSequence/:courseId/:testQueNum/:queType",
      component: exerciseSequence
    },
    {
      name: "train",
      path: "/train",
      redirect: "/trainHomePage",
      component: train,
      children: [
        {
          path: "/trainHomePage",
          component: trainHomePage
        },
        {
          path: "/learningConsultation",
          component: learningConsultation
        },
        {
          path: "/courseCenter/:workTypeId",
          component: courseCenter
        },
        {
          path: "/trainingPlan",
          component: trainingPlan
        },
        {
          path: "/liveClassroom",
          component: liveClassroom
        },
        {
          ///:streamName
          path: "/live/:courseId/:liveId/:courseName",
          component: live
        },
        {
          path: "/courseBuyDetail/:courseId/:workTypeName",
          component: courseBuyDetail
        },
        {
          ///:streamName
          path: "/personalCenter",
          component: personalCenter,
          redirect: "/trainPlanPersonal",
          children: [
            {
              path: "/mySelfBuyCourse",
              component: mySelfBuyCourse
            },
            {
              path: "/trainingProgram",
              component: trainingProgram
            },
            {
              path: "/myAccount",
              component: myAccount
            },
            {
              path: "/accountSet",
              component: accountSet
            },
            {
              path: "/trainPlanPersonal",
              component: trainPlanPersonal
            },
            {
              path: "/trainPlanCourse/:classId",
              component: trainPlanCourse
            },
            {
              path: "/resetThePassword",
              component: resetThePassword
            }
          ]
        },
        {
          path: "/courseDetail/:courseId/:classId/:workTypeId/:classType",
          component: courseDetail
        }
      ]
    },
    {
      name: "coursePay",
      path: "/coursePay",
      component: coursePay
    },
    {
      name: "video",
      path: "/video/:courseId/:classId/:chapterId/:compareCourseFace",
      component: video
    },
    {
      name: "retrievePassword",
      path: "/retrievePassword",
      component: retrievePassword
    },
    {
      name: "chapterTest",
      path:
        "/chapterTest/:courseId/:classId/:chapterId/:testId/:chapterName/:compareCourseFace",
      component: chapterTest
    },
    {
      name: "HeddleChangeArea",
      path: "/HeddleChangeArea",
      component: HeddleChangeArea,
      redirect: "/HeddleChangeAreaHomePage",
      children: [
        {
          path: "/HeddleChangeAreaHomePage",
          component: HeddleChangeAreaHomePage
        },
        //综改区认定相关
        {
          path: "/affirm1/:workTypeLevelState/:state",
          redirect: "/beginHomePage1/:workTypeLevelState/:state",
          component: affirm,
          //认定页面 中再加层级包含 就在其中加 children
          children: [
            //认定说明
            {
              path: "/affirmExplain1",
              component: affirmExplain
            },
            //开始认定首页
            {
              path: "/beginHomePage1/:workTypeLevelState/:state",
              component: beginHomePage
            },
            // 个人信息
            {
              path: "/personalInformation1/:workTypeLevelState/:state",
              component: personalInformation
            },
            //开始认定
            {
              path: "/beginAffirm1/:workTypeLevelState/:state",
              component: beginAffirm
            },
            //认定资料上传
            {
              path: "/affirmUploadData1/:workTypeLevelState/:state",
              component: affirmUploadData
            },
            //取消申报
            {
              path: "/affirmcancel1/:workTypeLevelState/:state",
              component: affirmcancel
            },
            //认定缴费
            {
              path: "/affirmPayTheFees1/:workTypeLevelState/:state",
              component: affirmPayTheFees
            },
            //培训缴费
            {
              path: "/trainPayTheFees1/:workTypeLevelState/:state",
              component: trainPayTheFees
            },
            //我的认定
            {
              path: "/affirmrecord1/:workTypeLevelState/:state",
              component: affirmrecord
            },
            //修改密码
            {
              path: "/affirmChangePassword1",
              component: affirmChangePassword
            },
            //消息通知
            {
              path: "/affirmMessageNotification1",
              component: affirmMessageNotification
            },
            //职业标准
            {
              path: "/affirmProfessionalStandard1/:workTypeLevelState",
              component: affirmProfessionalStandard
            }
          ]
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js